const MapIcon = props => (
  <svg
    width={32}
    height={32}
    viewBox="0 0 32 32"
    fill="black"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M24.5 7L24.34 7.03L19 9.1L13 7L7.36 8.9C7.15 8.97 7 9.15 7 9.38V24.5C7 24.78 7.22 25 7.5 25L7.66 24.97L13 22.9L19 25L24.64 23.1C24.85 23.03 25 22.85 25 22.62V7.5C25 7.22 24.78 7 24.5 7ZM19 23L13 20.89V9L19 11.11V23Z" />
  </svg>
)

export default MapIcon
